const HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

const convertHexToRgb = (hexColor: string): number[] => {
  let color = hexColor.slice(1);

  hexColor[4] || (color = color.replace(/./g,'$&$&'));

  const rgbColor = +(`0x${color}`);

  // eslint-disable-next-line no-mixed-operators
  return [rgbColor >> 16, rgbColor >> 8 & 255, rgbColor & 255];
};

// TODO: make this take colors in all format
const isColorLight = (hexColor: string) => {
  if (HEX_COLOR_REGEX.test(hexColor)) {
    const [red, blue, green] = convertHexToRgb(hexColor);

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
      0.299 * (red * red) +
      0.587 * (green * green) +
      0.114 * (blue * blue)
    );

    // Using the HSP value, determine whether the color is light or dark
    return hsp > 127.5;
  } else {
    console.error('Provide the color in HEX');
  }
};

export {
  convertHexToRgb,
  isColorLight
};
